<template>
    <div class="content">
        <div class="hw-content">
            <div class="content-head-title">合同支付信息</div>
            <div class="mb20" v-for="(item, index) in list" :key="index">
                <el-descriptions :column="2" border size="medium" labelClassName="custom-label">
                    <el-descriptions-item label="销售类型">
                        <div>{{ item.CateName || '' }}</div>
                    </el-descriptions-item>
                    <el-descriptions-item label="待支付金额">
                        <div>￥{{ item.Amount }}</div>
                    </el-descriptions-item>
                    <el-descriptions-item label="支付方式">
                        <div>{{ item.PayName || '--' }}</div>
                    </el-descriptions-item>
                    <div class="error" v-if="item.Select == 'false'">
                        {{ item.Message }}
                    </div>
                    <el-descriptions-item label="付款凭证" v-else>
                        <div>
                            <div>
                                <el-button size="mini" type="primary" @click="chooseVoucher({id:item.CateID,index:index,price:item.Amount})">选择凭证</el-button>
                                <el-button size="mini" type="primary" @click="searchVoucher(index)" v-if="item.ReceiptList && item.ReceiptList.length > 0">查看凭证</el-button>
                                <span style="color: red; margin-left: 10px">若有多张凭证请全部选择后再点击"提交"按钮</span>
                            </div>
                            <div style="margin-top: 10px" v-if="item.ReceiptList && item.ReceiptList.length > 0">
                                <el-table :data="item.ReceiptList" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                                    <el-table-column prop="Receipt_ID" label="ID" width="120" align="center" show-overflow-tooltip></el-table-column>
                                    <el-table-column prop="Receipt_BankName" label="汇入银行" align="center"></el-table-column>
                                    <el-table-column prop="Receipt_Type" label="凭证类型" align="center"></el-table-column>
                                    <el-table-column prop="Receipt_Code" label="汇款单位" align="center" width="200" show-overflow-tooltip></el-table-column>
                                    <el-table-column prop="Receipt_PayDate" label="付款日期" align="center"></el-table-column>
                                    <el-table-column prop="Receipt_Amount" label="汇款金额" align="center"></el-table-column>
                                    <el-table-column prop="Receipt_Addtime" label="录入时间" align="center"></el-table-column>
                                    <el-table-column prop="residuePrice" label="本次分配金额" align="center">
                                        <template slot-scope="scope">
                                            ￥{{ scope.row.residuePrice || 0 }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="移除" align="center">
                                        <template slot-scope="scope">
                                            <el-button type="text" @click="deleterVoucher({index:index,childrenIndex:scope.$index,id:scope.row.Receipt_ID})">移除</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </el-descriptions-item>
                </el-descriptions>
            </div>
            <div class="button-container">
                <el-button type="primary" @click="OrderPaySave">提交</el-button>
            </div>
            <el-dialog title="选择凭证" :visible.sync="isShowVoucher" width="1200px" :before-close="handleClose" v-if="isShowVoucher" append-to-body>
                <PackOrderVoucher :cateid="cateid" :residuePrice="residuePrice" @getPaymentReceipts="getPaymentReceipts"></PackOrderVoucher>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import PackOrderVoucher from '@/components/packOrderVoucher';

export default {
    name: 'ContractPay',
    components: {
        PackOrderVoucher
    },
    props: {
        OrdersID: {
            type: [String, Number],
            default: ''
        }
    },
    data() {
        return {
            list: [],
            isShowVoucher: false,
            cateid: '',
            residuePrice: 0,
            nowIndex: 0
        };
    },
    mounted() {
        if (this.OrdersID) {
            this.CheckOrdersPay();
        }
    },
    methods: {
        async CheckOrdersPay() {
            let result = await this.$newsApi.order.CheckSPCOrdersPay({
                OrdersID: this.OrdersID,
                ifBack: true
            });
            if(result && result.data && Array.isArray(result.data.data)) {
                result.data.data.map(item => {
                    item.receiptShow = false;
                    item.ReceiptList = [];
                    item.Receipt_ID = '';
                    item.Receipt_Amount = '';
                });
                this.list = result.data.data;
                let popShowIndex = result.data.data.findIndex((item) => item.Orders_IsNoCustomerSign == 1);
                if(popShowIndex != -1) {
                    this.$message('免盖章订单，请注意付款金额需等于订单金额！');
                }
            }
        },
        searchVoucher(index) {
            this.list.map(item => item.receiptShow = false);
            if(this.list[index].ReceiptList.length > 0) {
                this.list[index].receiptShow = true;
            } else {
                this.$message({
                    message: '当前订单暂未选择凭证',
                    type: 'warning'
                });
            }
        },
        chooseVoucher(e) {
            let residuePrice = 0;
            this.nowIndex = e.index;
            let arr = this.list[e.index].ReceiptList;
            for (let i = 0; i < arr.length; i++) {
                residuePrice += Number(arr[i].residuePrice || 0);
            }
            
            if (residuePrice > e.price) {
                residuePrice = 0;
            } else if (residuePrice === 0) {
                residuePrice = e.price;
            } else {
                residuePrice = (e.price - residuePrice).toFixed(2);
            }
            
            this.cateid = e.id;
            this.residuePrice = residuePrice;
            this.isShowVoucher = true;
        },
        getPaymentReceipts(json) {
            // 需要整合当前所有的Receipt_Amount,Receipt_ID参数
            if(this.list[this.nowIndex].ReceiptList.length > 0) {
                json['Receipt_ID_' + this.cateid] = this.list[this.nowIndex].Receipt_ID + ',' + json['Receipt_ID_' + this.cateid];
                json['Receipt_Amount_' + this.cateid] = this.list[this.nowIndex].Receipt_Amount + json['Receipt_Amount_' + this.cateid];
                this.showOrdersPaymentReceipt(json);
            } else {
                this.showOrdersPaymentReceipt(json);
            }
        },
        async showOrdersPaymentReceipt(e) {
            let json = JSON.stringify(e);
            let result = await this.$newsApi.order.ShowOrdersPaymentReceipt({
                Json: json,
                CateID: this.cateid
            });
            
            this.list[this.nowIndex].ReceiptList = result.data.data.list;
            this.list[this.nowIndex].Receipt_Amount = result.data.data.Receipt_Amount;
            this.list[this.nowIndex].Receipt_ID = result.data.data.Receipt_ID;
            
            let needList = result.data.data.Receipt_Amount.split(',');
            for (let i = 0; i < this.list[this.nowIndex].ReceiptList.length; i++) {
                this.list[this.nowIndex].ReceiptList[i].residuePrice = needList[i].split('|')[1];
            }
            
            this.isShowVoucher = false;
        },
        deleterVoucher(e) {
            this.$confirm('确定删除当前凭证吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
            .then(() => {
                let listData = this.list[e.index].ReceiptList.filter((item) => item.Receipt_ID != e.id);
                if(listData.length == 0) {
                    this.list[e.index].Receipt_Amount = '';
                    this.list[e.index].Receipt_ID = '';
                    this.list[e.index].ReceiptList = [];
                } else {
                    let amountArr = [];
                    let idArr = [];
                    for (let item of listData) {
                        amountArr.push(item.Receipt_ID + '|' + item.residuePrice);
                        idArr.push(item.Receipt_ID);
                    }
                    this.list[e.index].Receipt_Amount = amountArr.join();
                    this.list[e.index].Receipt_ID = idArr.join();
                    this.list[e.index].ReceiptList = listData;
                }
            })
            .catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });
            });
        },
        async OrderPaySave() {
            let json = {};
            let arr = JSON.parse(JSON.stringify(this.list));
            for (let i = 0; i < arr.length; i++) {
                if(arr[i].ReceiptList.length > 0) {
                    json['Receipt_ID_' + arr[i].CateID] = arr[i].Receipt_ID;
                    json['Receipt_Amount_' + arr[i].CateID] = arr[i].Receipt_Amount;
                }
            }
            json = JSON.stringify(json);
            let result = await this.$newsApi.order.SPCOrders_Pay({
                OrdersID: this.OrdersID,
                json: json
            });
            if (result.data.Resultcode == 0) {
                this.$message({
                    message: '操作成功！',
                    type: 'success'
                });
                this.$emit('ContractPayRes', true);
            }
        },
        handleClose() {
            this.isShowVoucher = false;
        }
    }
};
</script>

<style lang="scss" scoped>
.content {
    background: #fff;
}
.hw-content {
    padding: 20px;
}
.mb20 {
    margin-bottom: 20px;
}
.error {
    color: red;
    font-weight: 700;
    margin-bottom: 20px;
}
</style>